import { Api } from "../constants";
import { post, get, put } from "../helpers/apiHelper";
import { ReviewType } from "../types/admin";
import { ITEM_STATUS } from "../utils/constants";

const ADMIN_ALERT_TYPE = "ADMIN_ALERT";

export const broadcastAlert = async (title: string, message: string, severity: string) => {
  const url = `${Api.broadcastAlert}`;
  const payload = {
    type: ADMIN_ALERT_TYPE,
    level: severity,
    payload: {
      title,
      message,
      severity,
    },
  };
  return await post(url, payload);
};

export const fetchAdminDashboardStats = async () => {
  const url = `${Api.adminCounts}`;
  const response = await get(url);
  return response;
};

export const getReportedUsersAPI = async (reviewType: string, nextPageKey?: string | null, limit: number = 10) => {
  let url = `${Api.adminRestricted}/reported-users?reviewType=${reviewType}&limit=${limit}`;
  if (nextPageKey) {
    url += `&nextPageKey=${nextPageKey}`;
  }
  return await get(url);
};

export const getReportedUserDetailsAPI = async (reviewId: string) => {
  const url = `${Api.adminRestricted}/reported-users/${reviewId}`;
  return (await get(url));
};

export const getReportedItemDetailsAPI = async (reviewId: string) => {
  const url = `${Api.adminRestricted}/reported-items/${reviewId}`;
  return await get(url);
};

export const sendUserAlert = async (userId: string, title: string, message: string, severity: string) => {
  const url = `${Api.warnUser}`;
  const payload = {
    type: ADMIN_ALERT_TYPE,
    userId,
    level: severity,
    payload: {
      title,
      message,
      severity,
    },
  };
  return await post(url, payload);
};

export const updateUserAdminStatus = async (userId: string, status: string, blockedByAdmin: boolean) => {
  const url = `${Api.adminRestricted}/user/${userId}/status/${status}?blocked_by_admin=${blockedByAdmin}`;
  return await put(url, {});
};

export const updateReportStatus = async (reviewId: string) => {
  const url= `${Api.adminRestricted}/reported-users/${reviewId}/status/CLOSED`;
  return await put(url, {});
}

export const updateAdminItemListingStatusAPI = async (itemId: string, status: string) => {
  const url = `${Api.unlistItem}`;
  const payload = {
    itemId,
    status,
  };
  return await post(url, payload);
};

export const unlistItemAPI = async (itemId: string) => {
  return updateAdminItemListingStatusAPI(itemId, ITEM_STATUS.UNLISTED);
};

export const updateReviewStatus = async (reviewId: string, status: string, reviewType: ReviewType) => {
  const url = `${Api.adminRestricted}/reported-${reviewType.toLowerCase()}/${reviewId}/status/${status}`;
  return await put(url, {});
};
